import { useState } from 'react';

import { isStorageAvailable } from '../../common/utils/isStorageAvailable';

export default function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key if available
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item || initialValue;
    } catch (error) {
      // Output the error only if the localStorage is accessible.
      if (isStorageAvailable()) {
        console.warn(error);
      }
      // If error also return initialValue
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage if available
      window.localStorage.setItem(key, valueToStore);
    } catch (error) {
      // A more advanced implementation would handle the error case
      // Output the error only if the localStorage is accessible.
      if (isStorageAvailable()) {
        console.warn(error);
      }
    }
  };
  return [storedValue, setValue];
}
